import React, { useState, useEffect } from "react"
import { CSSTransition } from "react-transition-group"
import { useMedia } from "react-use"
import { filterVacancies, getVacanciesFilterValues } from "scripts/components/vacancies-page"
import Modal from "../Modal"
import Select from "../../select"

export default function ModalVacanciesFilter({
  vacancyFilterCategoryList,
  vacancyFilterCityList,
  defaultCategory = "all",
  defaultCity = "all",
}) {
  const [isModalFilterOpen, setIsModalFilterOpen] = useState(true)
  const [selectedVacancyCategory, setSelectedVacancyCategory] = useState(
    getVacanciesFilterValues().selectedVacancyCategory || defaultCategory,
  )
  const [selectedVacancyCity, setSelectedVacancyCity] = useState(
    getVacanciesFilterValues().selectedVacancyCity || defaultCity,
  )
  const isDesktop = useMedia("(min-width: 961px)");

  // const isModalFilterOpen = true

  useEffect(() => {
    if (isDesktop) {
      new Select({
        selector: ".select__vacancies-filter"
      })

      return () => {
        const customSelectElement = document.querySelector(".select__vacancies-filter + .select")
        if (customSelectElement) {
          customSelectElement.remove()
        }
      }
    }
  }, [])

  const vacancyCategorySelectHandler = (category) => {
    setSelectedVacancyCategory(category)
  }

  const vacancyCitySelectHandler = (e) => {
    setSelectedVacancyCity(e.target.value)
  }

  const applyButtonClickHandler = () => {
    setIsModalFilterOpen(false)
    filterVacancies({ selectedVacancyCategory, selectedVacancyCity })
  }

  return (
    <CSSTransition
      in={isModalFilterOpen}
      appear
      unmountOnExit
      classNames="fade"
      timeout={300}
    >
      <Modal
        title={window.labels.vacancies.modalFilter.title}
        modalView="xs"
        cssModifyer="-mobile-bottom-sheet"
        onRequestClose={() => setIsModalFilterOpen(false)}
      >
        <div className="form-content vacancy-filter-modal__type-list">
          <div className="body-r-14">
            <button
              type="button"
              data-text={window.labels.vacancies.allCategories}
              className={`vacancy-filter-modal__type-button ${
                selectedVacancyCategory === "all" ? "active" : ""
              }`}
              onClick={() => vacancyCategorySelectHandler("all")}
            >
              <span className="text">{window.labels.vacancies.allCategories}</span>
            </button>
            {vacancyFilterCategoryList.map((item) => (
              <button
                key={item.category}
                type="button"
                data-text={item.title}
                className={`vacancy-filter-modal__type-button ${
                  item.category === selectedVacancyCategory ? "active" : ""
                }`}
                onClick={() => vacancyCategorySelectHandler(item.category)}
              >
                <span className="text">{item.title}</span>
              </button>
            ))}
            {/* <span>{window.labels.checkout.certificates.confirmRemove.text}</span> */}
            <div className="form-select form-select--underline">
              <select
                className="select__current select__vacancies-filter"
                value={selectedVacancyCity}
                onChange={vacancyCitySelectHandler}
              >
                <option value="all">{window.labels.vacancies.allCities}</option>
                {vacancyFilterCityList.map((option) => (
                  <option key={option.city} value={option.city}>
                    {option.title}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <button
            type="button"
            className="wb-btn btn-green"
            onClick={applyButtonClickHandler}
          >
            <span>{window.labels.vacancies.modalFilter.confirm}</span>
          </button>
        </div>
      </Modal>
    </CSSTransition>
  )
}
